import {Component, Input, OnInit, ElementRef} from '@angular/core';

// Services
import {CatalogService} from '../../services/catalog-service';
import {CartService} from '../../services/cart-service';
import {AppService} from '../../../../shared/services/app-service'; // TODO: Decouple

// Classes
import {Product} from '../../classes/product';


let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductsListCmp'));

/**
 * Used to render navigation list in navigation sidebar
 * TODO: Update products per line on resize
 */
@Component({
    selector: 'products-list-cmp',
    template: require('./products-list.cmp.html'),
    styles: [String(require('./products-list.cmp.scss'))],
    host: { 'class': 'clearfix products-list'}
})
export class ProductsListCmp {

    @Input() category;

    public _imgPaths = this._catalogService.imgPaths;
    private _prodsPerLine = 4; // 4, 2, 1
    private _productsRows = null;
    private _productListElement = true;
    private _subscriptions: any = {};

    
    constructor (
        private _catalogService: CatalogService,
        private _cartService: CartService,
        private _elementRef: ElementRef,
        private _appService: AppService, // TODO: Remove dependency, catalgo should not know about app
    ) {
        // 'Construct products list component' );
    }

    
    ngOnInit() {
        // 'Initialise products list component' );

        this._sortProductsInRows();
        this._cacheDomElements();
        this._subscribeToEvents();
    }

    
    ngOnDestroy() {
        // 'Destroy products list component' );

        // Clear subscriptions
        for (let subscriptionId in this._subscriptions) {
            this._subscriptions[subscriptionId].unsubscribe();
        }
    }

    
    private _cacheDomElements () {
        debugOff( 'Cache dom elements' );

        this._productListElement = this._elementRef.nativeElement;
        debugOff( 'Product element:', this._productListElement );
    }

    
    private _subscribeToEvents () {
        debugOff( 'Subscribe to events' );

        let self = this;

        this._productListElement = this._cartService.events.cartUpdated.subscribe( () => {
            self._sortProductsInRows();
        });
        debugOff( 'Product element:', this._productListElement );
    }

    /** This operation is necessary in order to properly display the page structure without compromising rendering performance.
     */
    private _sortProductsInRows () {
        // 'Setup products in rows' );

        let self = this,
            index = 0,
            numOfRows = 0,
            visibleProducts,
            newRow;

        // Create rows object
        this._productsRows = [];

        if ( this.category.products === undefined ||
            this.category.products === null
        ){
            console.warn( 'Category "' + this.category.id + '" has no products' );
            return;
        }

        // Select just products visible
        visibleProducts = this.category.products.filter( (product: Product) => {
            return product.isVisible;
        });

        // Sort products per rows
        visibleProducts.forEach( (product: Product) => {
        // this.category.products.forEach( (product: Product) => {

            // Create new row
            if (index === 0) {
                newRow = [];
                self._productsRows.push( newRow );
            }

            // Add products to row
            newRow.push( product );

            index++;

            // Detect end of row
            if (index === this._prodsPerLine) {
                numOfRows++;
                index = 0;
            }

        });

        debugOff( 'Category product rows:', this._productsRows );

    }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/products/products-list.cmp.ts